import React, { useState } from 'react';

const Nav = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="w-full bg-blue-900 text-white py-4 px-8 flex justify-between items-center relative">
      <div className="font-bold text-2xl">
        CodeQueue
      </div>

      {/* Mobile Menu Button */}
      <button
        className="lg:hidden text-white text-3xl"
        onClick={toggleMobileMenu}
      >
        &#9776; {/* Hamburger icon */}
      </button>

      {/* Navigation Links */}
      <ul
        className={`lg:flex lg:space-x-6 space-y-4 lg:space-y-0 absolute lg:relative bg-blue-900 lg:bg-transparent w-full left-0 top-full lg:w-auto lg:flex-row p-8 lg:p-0 transition-all duration-300 ease-in-out z-50 ${
          isMobileMenuOpen ? 'block' : 'hidden'
        }`}
      >
        <li>
          <a
            href="#students-careers"
            className="hover:text-gray-300 text-blue-400 text-xl"
          >
            Students
          </a>
        </li>
        <li>
          <a
            href="#professionals"
            className="hover:text-gray-300 text-blue-400 text-xl"
          >
            Professionals
          </a>
        </li>
        <li>
          <a
            href="#locations"
            className="hover:text-gray-300 text-blue-400 text-xl"
          >
            Locations
          </a>
        </li>
        <li>
          <a
            href="#join-us"
            className="hover:text-gray-300 text-blue-400 text-xl"
          >
            Join Us
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Nav;
